import React, { PropsWithChildren } from 'react'

const Breadcrumb = (props: PropsWithChildren<any>) => {
    return <div className="breadcrumb">{props.children}</div>
}

export default Breadcrumb
